import React, { useState, useEffect } from "react";
import "./mobileCart.css";
import { useSelector } from "react-redux";
import { FaShoppingCart } from "react-icons/fa";
import SlideInModal from "../slideInModal/SlideInModal";
import Cart from "../Cart/Cart";

const MobileCart = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [shake, setShake] = useState(false);
  const products = useSelector((state) => state.cart.products);

  const openCart = () => {
    setIsModalOpen(true);
  };

  // Trigger shake animation when cart updates
  useEffect(() => {
    if (products.length > 0) {
      setShake(true);
      const timer = setTimeout(() => setShake(false), 500); // reset after animation
      return () => clearTimeout(timer);
    }
  }, [products.length]);

  return (
    <div>
      <div className="cart-icon">
        <div className="icon_wrp">
          <div className="_item" onClick={openCart}>
            <div className="_icons">
              <div className="shoppingCart">
                <div className={`cartIcon ${shake ? "shake" : ""}`}>
                  <FaShoppingCart size={20} color="white" />
                </div>
                <span className="_span">{products.length}</span>
              </div>
            </div>
          </div>
        </div>

        <SlideInModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        >
          <Cart closeCart={() => setIsModalOpen(false)} />
        </SlideInModal>
      </div>
    </div>
  );
};

export default MobileCart;
